export default "__VITE_ASSET__Dz85X1PK__"